export default function () {
  return {
    logged: JSON.parse(localStorage.getItem('logged')) || null,
    user: JSON.parse(localStorage.getItem('user')) || null,
    loading: false,
    dashdoardWidgets: [],
    dashboardLoading: false,
    userMenu: [],
    menuLoading: false
  }
}
